import {forwardRef, useImperativeHandle, useState} from 'react';
import {useSelector} from 'react-redux';
import clsx from 'clsx';
import _isNull from 'lodash/isNull';
import {useTranslation} from 'react-i18next';
import {agylePref} from '../../../../store/reducers/preferences';
import {Chip, FormLabel, Stack} from '@mui/material';
import {useSettingsStyles} from '../useSettingsStyles';
import {OPTION_BUTTONS_DEFAULT_GAP} from '../agyleMenuUtil';

const DEFAULT_STATE = {
    topMenuMode: 'open',
};

const MenuMode = forwardRef((props, ref) => {
    const classes = useSettingsStyles();
    const {t} = useTranslation();
    const agylePreference = useSelector(agylePref);

    const [mode, setMode] = useState(!_isNull(agylePreference?.topMenuMode) ? agylePreference?.topMenuMode : DEFAULT_STATE.topMenuMode);

    // Return default state of a component
    useImperativeHandle(ref, () => ({
        defaultState: () => {
            setMode(DEFAULT_STATE.topMenuMode);
            return DEFAULT_STATE;
        },
    }));

    const handleChange = (val) => {
        setMode(val);
        props.onChange('topMenuMode', val);
    };

    return (
        <div>
            <FormLabel>
                {t('Select the default behaviour of the top menu bar on the whiteboard')}
            </FormLabel>

          <Stack direction='row' gap={OPTION_BUTTONS_DEFAULT_GAP} sx={{mt: 1, my: .5}}>
            <Chip label="Open" className={clsx(mode === 'open' && classes.activeChip)} onClick={handleChange.bind(null, 'open')} />

            <Chip label="Mixed" className={clsx(mode === 'mixed' && classes.activeChip)} onClick={handleChange.bind(null, 'mixed')} />

            <Chip label="Close" className={clsx(mode === 'close' && classes.activeChip)} onClick={handleChange.bind(null, 'close')} />
          </Stack>
        </div>
    );
});

export default MenuMode;